export default __webpack_public_path__ + "static/media/pw.9832cf26.svg";